import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, Input, Button, Label } from "reactstrap";
import swal from "sweetalert";
import { accountSave, viewAccount } from "../../ApiEndPoint/Api";
import { _PostSave, _GetByUrl } from "../../ApiEndPoint/ApiCalling";

export default function Accounts() {
  const [accounts, setAccounts] = useState([]);

  const [form, setForm] = useState({
    groupName: "",
    ledgerName: "",
    manualLedger: "",
    side: "",
    accountType: [],
  });

  // 🔹 SAME group list
  const groupOptions = [
    "Purchase Accounts",
    "Sales Accounts",
    "Duties and Taxes",
    "Direct Expenses",
    "Indirect Expenses",
    "Direct Income",
    "Indirect Income",
    "Bank Accounts",
    "Deposit Accounts",
    "Capital Accounts",
    "Fixed Assets",
    "Current Assets",
    "Loans Liabilities",
    "Current Liabilities",
    "Sundry Creditor",
    "Loans and Advances (Assets)",
    "Suspense A/c",
    "Secured Loan",
    "Misc. Expense (ASSET)",
    "Stock-in-hand",
    "Investments",
  ];

  // 🔹 SAME mapping (short version)
  const ledgerOptionsByGroup = [
    {
      name: "Purchase Accounts",
      accountType: ["Trading Account"],
      side: "Debit",
      options: [
        "Purchases",
        "Purchase Local 12%",
        "Purchase Interstate 12%",
        "Purchase Local 0%",
        "Purchase Interstate 0%",
        "Purchase (Composition)",
        "Purchase Exempt (Unregistered Dealer)",
        "Purchase Local (Exempt Registered)",
        "Purchase Taxable (Unregistered Dealer)",
        "Purchase Nil Rated (Unregistered Dealer)",
        "Purchase Reverse Charge",
        "Purchase Import Taxable 12%",
        "Purchase Import Exempt",
        "Purchase Import Nil Rated",
        "Purchase (Own Branch)",
        "Purchase Return",
      ],
    },
    {
      name: "Sales Accounts",
      accountType: ["Trading Account"],
      side: "Credit",
      options: [
        "Sales Account",
        "Sales Local 12% (Registered)",
        "Sales Interstate 12%",
        "Sales Local Nil Rated",
        "Sales Interstate Nil Rated",
        "Sales Export With Bond",
        "Sales Export Taxable",
        "Export (0%)",
        "Sales Local (Exempt Registered)",
        "Sale To Consumer (Taxable 12%)",
        "Sale To Consumer (0%)",
        "Sale To Consumer (Exempt)",
        "Sales (Own Branch)",
        "Sale Return",
      ],
    },
    {
      name: "Duties and Taxes",
      accountType: ["Balance Sheet"],
      side: "Liability",
      options: [
        "INPUT CGST",
        "INPUT SGST",
        "INPUT IGST",
        "INPUT CESS",
        "OUTPUT GST",
        "OUTPUT SGST",
        "OUTPUT IGST",
        "OUTPUT CESS",
        "Excise Duty Payable",
        "Service Tax Payable",
        "TDS Payables",
        "Input VAT Accounts",
        "Output VAT Accounts",
        "Cenvat Accounts",
        "Sales Tax",
        "Income Tax",
        "VAT Payable",
      ],
    },
    {
      name: "Direct Expenses",
      accountType: ["Trading Account"],
      side: "Debit",
      options: [
        "Direct Expenses",
        "Labour",
        "Power",
        "Electricity Expense (Factory)",
        "Loading Unloading Expense",
        "Warehousing Expenses",
        "Custom Clearing Charges",
        "Carriage",
        "Freight & Cartage",
        "Import Duty",
        "Wages",
        "Coal & Fuel",
        "Coal, Gas & Water of Factory",
        "Consumed Material",
        "Export Duty",
        "Wages on Production",
        "Delivery Charges (In Purchase Bill)",
      ],
    },
    {
      name: "Indirect Expenses",
      accountType: ["Profit & Loss Account"],
      side: "Debit",
      options: [
        "Indirect Expenses",
        "Rounded Off",
        "Salary",
        "Advertisement Expense",
        "Maintenance Expense",
        "Rent Expense",
        "Director Remuneration Expense",
        "Bad Debts",
        "Printing Expense",
        "Stationary Expense",
        "Foreign Exchange Fluctuation",
        "Audit Fees",
        "Professional Charges",
        "Legal Expenses/Charges",
        "Depreciation Expenses",
        "Interest Expense",
        "Penalty",
        "Royalty",
        "Bank Charges",
        "Commission Allowed",
        "Discount Allowed",
        "Donation & Charity",
        "Free Sample",
        "Insurance Premium",
        "Interest on Loan",
        "Legal Charge",
        "Loss by Fire",
        "Postage & Courier",
        "Repair Charge",
        "Taxi Fare",
        "Telephone Charge",
        "Travelling Expenses",
        "Outstanding Expenses",
        "Accrued Expenses",
        "Bad Debt",
        "Loss on Theft",
        "Depreciation",
        "Coffee Expenses",
        "Coke Expenses",
        "Manager’s Commission",
        "UPTT",
        "Fuel Expenses A/c",
        "Liability of Expenses",
        "Preliminary Expenses A/c",
        "Professional Fees",
      ],
    },
    {
      name: "Direct Income",
      accountType: ["Profit & Loss Account"],
      side: "Credit",
      options: [
        "Direct Income"
      ],
    },
    {
      name: "Indirect Income",
      accountType: ["Profit & Loss Account"],
      side: "Credit",
      options: [
        "Indirect Income",
        "Discount Received",
        "Interest on Investment",
      ],
    },
    {
      name: "Bank Accounts",
      accountType: ["Balance Sheet"],
      side: "Asset",
      options: [
        "All Bank FD Account",
        "(Personal Savings Account and FD not recorded)",
      ],
    },
    {
      name: "Deposit Accounts",
      accountType: ["Balance Sheet"],
      side: "Asset",
      options: [
        "Security Deposit",
        "Electricity Deposit",
        "Rent Deposit",
      ],
    },
    {
      name: "Capital Accounts",
      accountType: ["Balance Sheet"],
      side: "Liability",
      options: [
        "Capital Accounts",
        "Share Capital",
        "Partner Capital Account",
        "Partner Current Account",
        "Proprietor Account",
        "Drawings",
        "Life Insurance",
        "Equity Capital A/c",
        "Partners Capital A/c",
      ],
    },
    {
      name: "Fixed Assets",
      accountType: ["Balance Sheet"],
      side: "Asset",
      options: [
        "Furniture",
        "Machine",
        "Plant and Machinery",
        "Mobile",
        "Computers",
        "Furniture and Fittings",
        "Car",
        "Scooter",
        "Laptops",
        "Office Lighting",
        "Land & Building",
        "Goodwill",
        "Factory Lighting",
        "Air Conditioner",
        "Accumulated Depreciation",
      ],
    },
    {
      name: "Current Assets",
      accountType: ["Balance Sheet"],
      side: "Asset",
      options: [
        "Prepaid Maintenance Expense",
        "Prepaid Expense",
        "Prepaid Rent",
        "Prepaid Insurance Charges",
        "Interest Receivables",
        "Bill Receivable",
        "Accrued Income",
        "Mutual Fund",
        "CGST Credit",
        "SGST Credit",
        "IGST Credit",
      ],
    },
    {
      name: "Loans Liabilities",
      accountType: ["Balance Sheet"],
      side: "Liability",
      options: [
        "Debenture A/c",
        "Loans From Bank",
        "Loans From Outside Party",
        "Loans From Aravind (Friend)",
      ],
    },
    {
      name: "Current Liabilities",
      accountType: ["Balance Sheet"],
      side: "Liability",
      options: [
        "Bill Drawn",
        "Bill Payable",
        "CGST Payable",
        "SGST Payable",
        "IGST Payable",
      ],
    },
    {
      name: "Sundry Creditor",
      accountType: ["Balance Sheet"],
      side: "Liability",
      options: [
        "Any Party from Whom Goods Purchased",
        "Party from Whom any Bill of Expense Received",
      ],
    },
    {
      name: "Loans and Advances (Assets)",
      accountType: ["Balance Sheet"],
      side: "Asset",
      options: [
        "Loan Given to Friends",
        "Loan Given to Relatives",
        "Loan Given to Related Companies",
        "Advance to Supplier",
      ],
    },
    {
      name: "Suspense A/c",
      accountType: ["Balance Sheet"],
      side: "Asset",
      options: [
        "Any payment or receipt from party whose name not known",
        "Suspense"
      ],
    },
    {
      name: "Misc. Expense (ASSET)",
      accountType: ["Balance Sheet"],
      side: "Asset",
      options: [
        "Preliminary Expenses"
      ],
    },
    {
      name: "Stock-in-hand",
      accountType: ["Balance Sheet", "Trading Account"],
      side: "Asset",
      options: [
        "Stock",
        "Closing Stock",
        "Consignment Stock",
        "Opening Stock",
      ],
    },
    {
      name: "Investments",
      accountType: ["Balance Sheet"],
      side: "Asset",
      options: [
        // Add your specific investments here if any
      ],
    },
  ];

  const ledgerOptions = ledgerOptionsByGroup.find(
    (g) => g.name === form.groupName
  );

  // 📦 Fetch
  const fetchAccounts = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));

      if (!userData?.database) {
        console.warn("Database not found");
        return;
      }

      const res = await _GetByUrl(viewAccount, userData.database);

      if (res?.viewAccounts?.Accounts) {
        setAccounts(res.viewAccounts.Accounts);
      } else {
        setAccounts([]);
      }

    } catch (error) {
      console.error("Fetch Error:", error?.response?.data || error.message);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  // 🚀 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalLedger = form.ledgerName || form.manualLedger;

    if (!form.groupName || !finalLedger) {
      swal("Please fill required fields");
      return;
    }

    const finalData = {
      groupName: form.groupName,
      ledgerName: finalLedger,
      side: ledgerOptions?.side || form.side,
      accountType:
        form.accountType.length > 0
          ? form.accountType
          : ledgerOptions?.accountType,
    };

    try {
      const userData = JSON.parse(localStorage.getItem("userData"));

      const obj = {
        created_by: userData?._id,
        database: userData?.database,
        Accounts: [finalData],
      };
      const res = await _PostSave(accountSave, obj);

      if (res?.status) {
        swal("Success", "Account Saved", "success");

        // ✅ IMPORTANT
        await fetchAccounts();

        // reset form
        setForm({
          groupName: "",
          ledgerName: "",
          manualLedger: "",
          side: "",
          accountType: [],
        });
      } else {
        swal("Error saving account");
      }

    } catch (error) {
      console.error("Save Error:", error);
    }
  };

  return (
    <div className="erp-page-grid">
      <Card className="erp-card">
        <CardBody>
          <h3>Accounts</h3>

          {/* ✅ Form */}
          <form onSubmit={handleSubmit}>
            <Row>
              {/* Group */}
              <Col md="3">
                <Label>Group Name</Label>
                <Input
                  type="select"
                  value={form.groupName}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      groupName: e.target.value,
                      ledgerName: "",
                      manualLedger: "",
                    })
                  }
                >
                  <option value="">Select</option>
                  {groupOptions.map((g, i) => (
                    <option key={i}>{g}</option>
                  ))}
                </Input>
              </Col>

              {/* Ledger dropdown */}
              <Col md="3">
                <Label>Ledger Name</Label>
                <Input
                  type="select"
                  value={form.ledgerName}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      ledgerName: e.target.value,
                      manualLedger: "",
                    })
                  }
                >
                  <option value="">Select</option>
                  {ledgerOptions?.options?.map((l, i) => (
                    <option key={i}>{l}</option>
                  ))}
                </Input>
              </Col>

              {/* Manual Ledger */}
              <Col md="3">
                <Label>Or Manual</Label>
                <Input
                  value={form.manualLedger}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      manualLedger: e.target.value,

                    })
                  }
                />
              </Col>

              {/* Side auto */}
              <Col md="3">
                <Label>Side</Label>
                <Input value={ledgerOptions?.side || form.side} readOnly />
              </Col>
            </Row>

            <Button color="primary" style={{ marginTop: "20px" }}>
              Add Account
            </Button>
          </form>

          {/* Table */}
          <table className="table mt-3">
            <thead>
              <tr>
                <th>Group</th>
                <th>Ledger</th>
                <th>Side</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              {accounts?.length > 0 ? (
                accounts.map((a, i) => (
                  <tr key={i}>
                    <td>{a.groupName}</td>
                    <td>{a.ledgerName}</td>
                    <td>{a.side}</td>
                    <td>{Array.isArray(a.accountType) ? a.accountType.join(", ") : a.accountType}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </div>
  );
}